import React, { Component } from "react";
import "./search.css";
import config from "../config";
import ColorResults from "../ColorResults/ColorResults";
import loader from "../img/ajax-loader.gif";

class Search extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: false,
      searchTerm: null,
      mode: null,
      count: 4,
      results: null,
      threadColors: null,
      saved: false,
      loading: false,
    };
  }

  componentDidMount() {
    this.getAllThreadColors().then((response) =>
      this.setState({ threadColors: response })
    );
  }

  async getAllThreadColors() {
    const response = await fetch(`${config.API_ENDPOINT}/thread-colors`, {
      method: "GET",
      headers: {
        "content-type": "application/json",
      },
    })
      .then((threadColors) => {
        return threadColors.json();
      })
      .catch((res) => {
        this.setState({
          error: "Something went wrong, please try again later.",
        });
      });
    return response;
  }

  async generatePalette(colorCode, mode, count) {
    let params = `colorCode=${colorCode}`;

    if (mode) {
      params += `&mode=${mode}`;
    }
    if (count) {
      params += `&count=${count}`;
    }

    const response = await fetch(
      `${config.API_ENDPOINT}/color-palette?${params}`,
      {
        method: "GET",
        headers: {
          "content-type": "application/json",
        },
      }
    )
      .then((colors) => {
        return colors.json();
      })
      .catch((res) => {
        this.setState({
          error: "Something went wrong, please try again later.",
        });
      });
    return response;
  }

  handleSave = () => {
    this.setState({ saved: true });
  };

  resetSave = () => {
    this.setState({ saved: false });
  };

  handleSearchUpdate = (search) => {
    this.setState({
      searchTerm: search,
    });
  };

  handleModeUpdate = (mode) => {
    this.setState({
      mode: mode,
    });
  };

  handleCountUpdate = (count) => {
    this.setState({
      count: count,
    });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    this.clearResults();
    this.resetSave();
    const { searchTerm, mode, count } = this.state;

    if (!searchTerm) {
      this.setState({
        error: "Please select a color.",
      });
    } else {
      this.setState({ loading: true });
      this.generatePalette(searchTerm, mode, count).then((response) => {
        this.setState({ loading: false });
        this.setState({ results: response.results });
        let element = document.getElementById("auto-scroll");
        element.scrollIntoView({
          behavior: "smooth",
          block: "end",
          inline: "nearest",
        });
      });
    }
  };

  clearResults() {
    this.setState({ results: null, error: null });
  }

  render() {
    const threadColors = this.state.threadColors
      ? this.state.threadColors.data.sort().map((color, i) => {
          let rgb = `${color.r}, ${color.g}, ${color.b}, 0.7`;
          return (
            <option
              style={{ backgroundColor: `rgb(${rgb})` }}
              value={color.color_code}
              name={color.color_name}
              key={i}
            >{`${color.color_code ? color.color_code : ""} (${
              color.color_name
            })`}</option>
          );
        })
      : "";
    return (
      <div className="color-palette">
        <form className="search-bar" onSubmit={(e) => this.handleSubmit(e)}>
          <h1>Thread Palette Generator</h1>
          <div className="embroidery-colors">
            <label htmlFor="color">Select a DMC color:</label>
            <select
              name="color"
              className="select-stitch hover:ring"
              onChange={(e) => this.handleSearchUpdate(e.target.value)}
            >
              <option value="" name="choose-a-color">
                Choose a Color
              </option>
              {threadColors}
            </select>
          </div>
          <div>
            <label htmlFor="mode">Color scheme:</label>
            <select
              name="mode"
              className="select-mode hover:ring"
              onChange={(e) => this.handleModeUpdate(e.target.value)}
            >
              <option value="monochrome" name="monochrome">
                Monochrome
              </option>
              <option value="monochrome-light" name="monochrome-light">
                Monochrome Light
              </option>
              <option value="monochrome-dark" name="monochrome-dark">
                Monochrome Dark
              </option>
              <option value="complement" name="complement">
                Complementary
              </option>
              <option value="analogic" name="analogic">
                Analogic
              </option>
              <option value="analogic-complement" name="analogic-complement">
                Analogic Complement
              </option>
              <option value="triad" name="triad">
                Triad
              </option>
              <option value="quad" name="quad">
                Quad
              </option>
            </select>
          </div>
          <div>
            <label htmlFor="count">Number of colors in palette:</label>
            <select
              name="count"
              className="select-count hover:ring"
              onChange={(e) => this.handleCountUpdate(e.target.value)}
            >
              <option value="4" name="4">
                4
              </option>
              <option value="5" name="5">
                5
              </option>
              <option value="6" name="6">
                6
              </option>
              <option value="7" name="7">
                7
              </option>
              <option value="8" name="8">
                8
              </option>
              <option value="9" name="9">
                9
              </option>
              <option value="10" name="10">
                10
              </option>
            </select>
          </div>
          <div className="error-container">
            <p className="error-message">
              {this.state.error ? this.state.error : null}
            </p>
          </div>
          <div className="form-buttons">
            <button type="submit">Submit</button>
            <button type="button" onClick={() => this.clearResults()}>
              Clear Results
            </button>
          </div>
        </form>
        {this.state.loading && (
          <img src={loader} alt="loading icon" className="loader" />
        )}
        <ColorResults
          results={this.state.results}
          saved={this.state.saved}
          handleSave={this.handleSave}
          resetSave={this.resetSave}
        />
      </div>
    );
  }
}

export default Search;
